/**
 * Scroll state lives outside React.
 *
 * ScrollTrigger writes here on every frame it updates; the R3F scene reads it
 * inside `useFrame`. Routing scroll through component state instead would
 * re-render the tree sixty times a second for a value only the canvas uses.
 */

export interface ScrollState {
  /** Hero stage progress, 0 at the top of the pin to 1 at its end. */
  heroProgress: number;
  /** Which of the hero copy chapters is live, as a whole number. */
  heroChapter: number;
}

const state: ScrollState = { heroProgress: 0, heroChapter: 0 };
const listeners = new Set<() => void>();

/**
 * The canvas renders on demand, so it has to be told when the value it draws
 * from has moved. Returns the unsubscribe.
 */
export function subscribeScroll(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function readScroll(): Readonly<ScrollState> {
  return state;
}

export function writeHeroProgress(progress: number, chapterCount: number): void {
  const clamped = Math.min(Math.max(progress, 0), 1);
  state.heroProgress = clamped;
  state.heroChapter = Math.min(Math.floor(clamped * chapterCount), chapterCount - 1);
  listeners.forEach((listener) => listener());
}
